export function base64Encode(data: any): string {
  let result = '';

  if (typeof data === 'string') {
    result = btoa(data);
  } else {
    try {
      const textEncoder = new TextEncoder();
      const encodedData = textEncoder.encode(JSON.stringify(data));
      result = btoa(String.fromCharCode(...encodedData));
    } catch (error) {
      console.error('Error encoding data to base64', error);
      return '';
    }
  }

  return result;
}
